<div class="p-1 size-full flex flex-col items-center justify-center gap-5">
  <div class="w-full h-auto p-2">
    <p-message severity="info" icon="pi pi-info-circle" size="small" class="w-full">
      Przypisz numer kluczyka do pojazdu. System domyślnie sugeruje pierwszy, wolny numer kluczyka.
    </p-message>
  </div>

  <div class="w-full h-auto p-2">
    <app-select-input
      class="w-full"
      [formControl]="keyNumber"
      [options]="facade.availableKeyNumbers$ | async" [filter]="true" [filterPlaceholder]="'Szukaj numeru kluczyka'"
      [showLoading]="isLoading()"
      [showClear]="true"
      [autoOptionFocus]="true"
      label="Numer kluczyka"
      [labelMode]="'fixed'"
      [virtualScroll]="true">
    </app-select-input>
  </div>

  <div class="w-full inline-flex justify-end h-auto p-2 gap-2">
    <p-button
      label="Anuluj"
      rounded
      outlined
      (click)="onCancel()">
    </p-button>
    <p-button
      label="Przypisz"
      rounded
      [disabled]="keyNumber.invalid"
      (click)="onApply()">
    </p-button>
  </div>
</div>
